<template>
    <div>
        <h5>{{ $t('recover_password') }}?</h5>
        <form v-on:submit.prevent="recover">
            <ValidationObserver ref="formRecover">
                <p v-if="this.$Params.recover == '2'">{{ $t('info_recover') }}</p>
                <p v-else>{{ $t('info_recoverPregunta') }}</p>
                <ValidationProvider :rules="rules.recover" name="vpUserRecover" v-slot="{ valid, validated }">
                    <div class="input-group mb-3" :class="{ 'error-asterisk': !valid && validated }">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                            </span>
                        </div>
                        <input type="text" class="form-control" v-model="userModel.username" @keyup="keyup"
                            :placeholder="$t('insert_user')" :readonly="txtQuestion != ''">
                    </div>
                </ValidationProvider>
                <div class="form-group" v-if="this.$Params.recover == '1' || this.$Params.recover == '3'">
                    <label>{{ $t('info_recoverSeguridadSocial') }}</label>
                    <input id="segsoc" type="text" class="form-control" v-model="userModel.segsoc"
                        :readonly="txtQuestion != ''">
                </div>
                <div class="form-group" v-if="this.$Params.recover == '1' || this.$Params.recover == '3'">
                    <label>{{ $t('info_recoverBirthDate') }}</label>
                    <input id="fechaNacimiento" type="text" :placeholder="$t('label_recoverDateFormat')" class="form-control"
                        v-model="userModel.fechaNacimiento" :readonly="txtQuestion != ''">
                </div>
                <div class="form-group" v-if="this.txtQuestion">
                    <label><strong>{{ $t('label_recoverQuestion') }}</strong> <span>{{ txtQuestion }}</span></label>
                    <input id="pregunta" type="text" class="form-control" v-model="userModel.pregunta">
                </div>
            </ValidationObserver>

            <mmButton :text="$t('btn_recover')" classe="btn btn-primary btn-block font-16" :click="recover"></mmButton>

        </form>
    </div>
</template>

<script>
import { userService } from '@/api/user';
import { rules } from "@/_helpers/validations/validate-login";
import mmButton from '@mysummar/summar-vue/src/components/mmButton.vue';
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
    name: 'Loggin',
    data() {
        return {
            rules,
            userModel: {
                username: '',
                segsoc: '',
                fechaNacimiento: ''
            },
            txtQuestion: '',
        }
    },
    components: {
        mmButton,
        ValidationObserver,
        ValidationProvider
    },
    methods: {
        async recover() {

            let valid = await this.$refs.formRecover.validate();

            if (valid) {
                let respuesta = await userService.recover(this.userModel);

                if (respuesta.message == 'question_required') {
                    let question = await userService.recoverQuestion(this.userModel.username);
                    this.txtQuestion = question;
                    return;
                }

                let typeMessage = 'danger';

                if (respuesta.message == 'recoverPassword') {
                    //sino hay token, mostrar el mensaje de que se ha enviado un email
                    this.$router.push('/reset?token=' + respuesta.token);
                    typeMessage = 'info';
                }

                if (respuesta.message == 'recoverPasswordEmail') typeMessage = 'success';

                if (respuesta.valid)
                    this.userRecover = '';

                this.$parent.$emit('updateMessage', this.$i18n.t(`messages.${respuesta.message}`), typeMessage);
            }
        },
        keyup() {
            this.$parent.$emit('hideMessage');
        }
    }
}
</script>